import React, { useEffect, useState } from "react";
import "./Analytics.css";
import { getAllUsers } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";

const AnalyticsHeader = ({ onDownload, selectedMerchant, setSelectedMerchant }) => {
  const token = useSelector((store) => store.userReducer.token);

  const [merchantNames, setMerchantNames] = useState([]);

  useEffect(() => {
    const fetchMerchNames = async () => {
      try {
        const response = await getAllUsers(token, 1);

        const filteredData = response.data.filter(
          (merchant) => merchant.role === "admin"
        );
        // console.log("Filtered Merchants:", filteredData);

        setMerchantNames(filteredData);
      } catch (error) {
        console.error("Error fetching merchants:", error);
      }
    };

    fetchMerchNames();
  }, [token]);

  const MerchantOptions = merchantNames.map((item) => ({
    value: item.id,
    label: item.alias,
  }));

  return (
    <div
      className="analytics-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <h2>User Ledger</h2>
        <p style={{ marginTop: "5px", color: "#666" }}>
          Showing Auto Generated Ledger
        </p>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <ReactSelect
          value={selectedMerchant}
          options={MerchantOptions}
          onChange={setSelectedMerchant} // ✅ directly use prop
          placeholder="Select Merchant"
          isClearable
        />

        <button
          onClick={onDownload}
          style={{
            padding: "8px 16px",
            background: "#1677ff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Download Excel
        </button>
      </div>
    </div>
  );
};

export default AnalyticsHeader;